import { CopyButton } from 'components';
import { Entry } from 'types';

function ProductEntryLoading() {
  return (
    <div className="flex gap-4 py-2">
      <div className="size-16 animate-pulse rounded bg-neutral-300" />
      <div className="flex flex-grow flex-col gap-2">
        <div className="h-4 w-3/4 animate-pulse rounded bg-neutral-300" />
        <div className="h-3 w-1/2 animate-pulse rounded bg-neutral-300" />
        <div className="flex gap-2">
          <div className="h-3 w-16 animate-pulse rounded bg-neutral-300" />
          <div className="h-3 w-4 animate-pulse rounded bg-neutral-300" />
        </div>
      </div>
    </div>
  );
}

export function ProductEntry({ entry }: { entry?: Entry }) {
  if (!entry) return <ProductEntryLoading />;

  const { product: { image, name = '', code = '' } = {}, quantity } = entry;

  return (
    <div className="flex gap-4 py-2">
      <div className="relative size-16 bg-neutral-300">
        {image && (
          <img src={image} className="h-full w-full object-cover" alt={name} />
        )}
      </div>

      <div
        className="flex flex-grow flex-col gap-2 text-font12 text-neutral-500"
      >
        <p className="font-light">{name}</p>
        <div className="flex items-center gap-2">
          <p className="font-semibold">{code}</p>
          <CopyButton content={code} />
        </div>
        <div className="flex gap-2">
          <p className="font-light">Quantidade</p>
          <p className="font-bold">{quantity}</p>
        </div>
      </div>
    </div>
  );
}
